import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { ACCOUNT_TYPE_NORMAL, API_BASE_URL } from "@config/config";

const fetchMembershipInfo = async (userId) => {
    const res = await axios.get(`${API_BASE_URL}/movie-club-purchase/${userId}`);
    return res.data.data;
};

export const useMembershipInfo = (user) => {
    const { data, isLoading } = useQuery({
        queryKey: ["membershipInfo", user?.id],
        queryFn: () => fetchMembershipInfo(user.id),
        enabled: !!user?.id && user?.account_type_id === ACCOUNT_TYPE_NORMAL,
        staleTime: Infinity,
    });

    return {
        memberData: data?.membershipData ?? null,
        isMembershipExpired: data?.isMembershipExpired ?? false,
        isMembershipInfoLoading: isLoading,
    };
};
